import { CRM_WEB_PAGES_URLS } from '../../CRM_WEB_PAGES_URLS';
import { OrganizationSettings } from '@care-portals/api-interfaces';

export const flamingo_pharmacy: OrganizationSettings = {
  name: 'Flamingo Pharmacy',
  replyToEmail: 'doctor@secure-message.appgen.health',
  ecommerceEnabled: false,
  stripeEnabled: false,
  conversationServiceId: '',
  appointmentconsentSection: `
        <p style="text-align: center;color: #536476;">
          By clicking on {{cta_label}} you agree to our:<br />
          <a
            href="javascript:window.open('https://flamingopharmacy.com/privacy-policy', 'popup', 'width=600,height=600');"
          >
              Privacy Policies
          </a>
          <br>
          <a
            href="javascript:window.open('https://flamingopharmacy.com/terms-conditions', 'popup', 'width=600,height=600');"
          >
            General Terms & Conditions
          </a>
          <br>
          <a
              href="javascript:window.open('https://flamingopharmacy.com/antigen-test-service-agreement', 'popup', 'width=600,height=600');"
            >
            Antigen Test Service Agreement</a>
        </p>
      `,

  // navigation
  crmWebAppLayout: {
    title: 'Flamingo Pharmacy',
    icon: 'https://uploads-ssl.webflow.com/630cf5c3fde88d3fa5008ecc/64e7b973df75be3a06fd7e77_icon-flamingo.svg?ssl=1',
    logo: 'https://flamingopharmacy.com/wp-content/uploads/2021/01/logo.svg',
    mainMenu: [
      {
        title: 'Leads',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fa-regular fa-address-book',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fa-regular fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fa-solid fa-list-check',
        roles: ['*']
      },
      {
        title: 'Segments',
        link: CRM_WEB_PAGES_URLS.segment.list,
        icon: 'fa-solid fa-table-columns',
        roles: ['*']
      },
      {
        title: 'Admin',
        link: '',
        icon: 'fas fa-user-cog',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Services',
            link: CRM_WEB_PAGES_URLS.services.list,
            icon: 'fas fa-medkit'
          },
          {
            title: 'Schedules',
            link: CRM_WEB_PAGES_URLS.schedules.list,
            icon: 'fas fa-calendar'
          },
          {
            title: 'Users',
            link: CRM_WEB_PAGES_URLS.users.list,
            icon: 'fas fa-lock'
          },
          {
            title: 'Forms',
            link: CRM_WEB_PAGES_URLS.forms.list,
            icon: 'fas fa-table'
          },
          {
            title: 'Workflows',
            link: CRM_WEB_PAGES_URLS.workflows.list,
            icon: 'fas fa-code-branch'
          },
          {
            title: 'Settings',
            link: CRM_WEB_PAGES_URLS.settings.base,
            icon: 'fa-solid fa-sliders'
          }
        ]
      }
    ]
  }
};
